import React from 'react';

interface EmailActionsProps {
  isEditMode: boolean;
  isSending: boolean;
  onToggleEdit: () => void;
  onSaveDraft: () => void;
  onSendEmail: () => void;
  hideSubmitButton?: boolean;
  isDraft?: boolean;
}

const EmailActions: React.FC<EmailActionsProps> = ({
  isEditMode,
  isSending,
  onToggleEdit,
  onSaveDraft,
  onSendEmail,
  hideSubmitButton,
  isDraft = true,
}) => {
  // Only drafts have actions (Edit/Save/Send)
  if (!isDraft) {
    return null;
  }

  return (
    <div className='extra-bottom-wrapper'>
      <div className='email-actions'>
        <h4 className='email-actions-title'>Email Actions</h4>
        <div className='email-actions-buttons'>
          {isDraft && isEditMode ? (
            <>
              <button
                className='email-action-btn cancel-btn'
                onClick={onToggleEdit}
                disabled={isSending}
              >
                Cancel
              </button>
              <button
                className='email-action-btn save-btn'
                onClick={onSaveDraft}
                disabled={isSending}
              >
                Save
              </button>
            </>
          ) : (
            <>
              {isDraft && (
                <button
                  className='email-action-btn'
                  onClick={onToggleEdit}
                  disabled={isSending}
                >
                  Edit
                </button>
              )}
              {isDraft && !hideSubmitButton && (
                <button
                  className='email-action-btn send-btn'
                  onClick={onSendEmail}
                  disabled={isSending}
                >
                  {isSending ? 'Sending...' : 'Send'}
                </button>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmailActions;
